"use strict";

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

$.event.special.myInvade = {
    setup: function(margin){
        var $e = $(this);
        var flg = false;
        var func = function(){
            if(flg){
                return;
            }
            var e_top = $e.offset().top;
            var a_btm = Math.ceil($(window).scrollTop()+$(window).height()*(1-margin));
            if(e_top < a_btm){
                flg = true;
                $e.trigger("myInvade", false);
            }
        };
        $(window).on("scroll.myinvade", func).on("resize.myinvade", func).on("load.myinvade", func);
    }
};

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

//================
var Toolkit = function(){ var THIS=this;
    THIS.flg = {
        scrolling: false
    };
};

(function(){
this.checkUA = function(name){ var THIS=this;
    var ua = navigator.userAgent.toLowerCase();
    if(ua.indexOf(name.toLowerCase()) !== -1){
        return true;
    }
    return false;
};
this.mediaQuery = function(bparr, cb1, cb2){ var THIS=this;
    var mm = [];
    for(var i=0,imax=bparr.length; i<imax; i++){
        mm.push(window.matchMedia("(max-width:"+bparr[i]+"px)"));
        mm[i].addListener(function(ev){
            cb2(ev.media.match(/[0-9]/g).join("")*1, ev.matches);
        });
    }
    var idx = -1;
    for(var i=0,imax=mm.length; i<imax; i++){
        if(mm[i].matches){
            idx = i;
            break;
        }
    }
    if(idx === -1){
        cb1(-1);
    }else{
        cb1(bparr[idx]);
    }
};
this.sprintf = function(str, prm){ var THIS=this;
    for(var i=0,imax=prm.length; i<imax; i++){
        str = str.replace(new RegExp("{%}"), prm[i]);
    }
    return str;
};
this.scroll = function($e, mgn, dur, cb){ var THIS=this; if(mgn==null)mgn=40; if(dur==null)dur=400; if(cb==null)cb=function(){};
    if(THIS.flg.scrolling){
        return;
    }
    THIS.flg.scrolling = true;
    
    var ypos = 0;
    var c    = 0;
    if($e && $e.length === 1){
        ypos = $e.offset().top - mgn;
    }
    $("html,body").animate({scrollTop:ypos}, dur, "swing", function(){
        c++;
        if(c > 1){
            THIS.flg.scrolling = false;
            cb();
        }
    });
};
this.stepRun = function(fnarr, onfail, onend){ var THIS=this; if(onfail==null)onfail=function(){};if(onend==null)onend=function(){};
    var i = 0;
    var exec = function(){
        if(i >= fnarr.length){
            onend();
            return;
        }
        $.when((function(){
            var d = new $.Deferred();
            fnarr[i](d.resolve, d.reject);
            return d.promise();
        })()).then(exec, onfail);
        i++;
    };
    exec();
};
}).call(Toolkit.prototype);

//================
var Modalbox = function($e, options){ var THIS=this;
    THIS.id       = $e[0].id;
    THIS.working  = false;
    THIS.sta      = false;
    THIS.$box     = null;
    THIS.$wrap    = null;
    THIS.$bg      = null;
    THIS.lockpos  = 0;
    THIS.opt      = $.extend({
        speed   : [400,400],
        bgColor : "rgba(0,0,0,0)",
        zIndex  : 1,
        appendTo: "body"
    }, options);
    
    var cssObj = {
        bg:{
            position       :"absolute",
            left           :0,
            top            :0,
            width          :"100%",
            backgroundColor:THIS.opt.bgColor,
            zIndex         :THIS.opt.zIndex,
            opacity        :0
        },
        wrap:{
            position:"absolute",
            left    :0,
            top     :0,
            width   :"100%",
            overflow:"auto"
        }
    };
    
    THIS.$box = $e.detach().on("click", function(e){
        e.stopPropagation();
    });
    THIS.$wrap = $('<div>').attr({id:THIS.id+"-mbwrap"}).css(cssObj.wrap);
    THIS.$bg = $('<div>').attr({id:THIS.id+"-mbbg"}).css(cssObj.bg).hide();
    
    $(THIS.opt.appendTo).append(THIS.$bg.append(THIS.$wrap.append(THIS.$box)));
    
    $(window).on("resize.modalbox", function(){
        if(!THIS.sta){
            return;
        }
        THIS.fitpos();
    });
};

(function(){
this.show = function(cb){ var THIS=this; if(cb==null)cb=function(){};
    if(THIS.working){
        return;
    }
    THIS.working = true;
    
    THIS.lockpos = $(window).scrollTop();
    THIS.$bg.css({height:$(document).height()+THIS.addressbarHeight()});
    $("body").css({position:"fixed", top:-1*THIS.lockpos, width:"100%", height:"100%"});
    THIS.$wrap.css({marginTop:THIS.lockpos});
    THIS.fitpos();
    THIS.$bg.show().animate({opacity:1}, THIS.opt.speed[0], "linear", function(){
        THIS.sta = true;
        THIS.working = false;
        
        cb();
    });
};
this.hide = function(cb){ var THIS=this; if(cb==null)cb=function(){};
    if(THIS.working){
        return;
    }
    THIS.working = true;
    
    THIS.$bg.animate({opacity:0}, THIS.opt.speed[1], "linear", function(){
        THIS.$bg.hide();
        
        $("body").css({position:"", top:"", width:"", height:""});
        var lp = 0;
        $("html,body").animate({scrollTop:THIS.lockpos}, 0, function(){
            lp++;
            if(lp === 1){
                return;
            }
            THIS.sta = false;
            THIS.working = false;
            
            cb();
        });
    });
};
this.fitpos = function(){ var THIS=this;
    THIS.$wrap.css({height:$(window).height()});
};
this.addressbarHeight = function(){ var THIS=this;
    return document.documentElement.clientHeight - window.innerHeight;
};
}).call(Modalbox.prototype);

//================
var MvPlayer = function($e, vsrc, option){ var THIS = this;
    THIS.$e       = $e;
    THIS.mv       = $e[0];
    THIS.flg      = {
        playing: false
    };
    THIS.tm       = null;
    THIS.opt      = $.extend({
        msec       : 200,
        defaultplay: true,
        onReady    : function(mv){},
        onTimeupd  : function(mv){},
        onEnd      : function(mv){}
    }, option);
    
    $e.on("loadedmetadata", function(){
        THIS.mv.pause();
        THIS.mv.muted = true;
        THIS.mv.playsinline = true;
        THIS.mv.currentTime = 0;
        
        THIS.opt.onReady(THIS.mv);
    }).on("timeupdate", function(){
        THIS.opt.onTimeupd(THIS.mv);
    }).on("ended", function(){
        THIS.opt.onEnd(THIS.mv);
    });
    $e.attr({src:vsrc});
};
(function(){

this.restart = function(){ var THIS=this;
    THIS.flg.playing = true;
    
    if(THIS.opt.defaultplay){
        THIS.mv.currentTime = 0;
        THIS.mv.play();
    }else{
        THIS.mv.currentTime = 0;
        THIS.tm = setInterval(function(){
            var _t = (THIS.mv.currentTime+(THIS.opt.msec/1000)).toFixed(2)*1;
            THIS.mv.currentTime = _t;
            if(THIS.mv.currentTime >= THIS.mv.duration){
                clearInterval(THIS.tm);
            }
        }, THIS.opt.msec);
    }
};
this.stop = function(){ var THIS=this;
    if(THIS.opt.defaultplay){
        THIS.mv.pause();
    }else{
        clearInterval(THIS.tm);
    }
    THIS.flg.playing = false;
};

}).call(MvPlayer.prototype);

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

$(function(){

//========================================
var CONST = {};
CONST.BREAKPOINT = 768;

var Tk = new Toolkit();
Tk.isPC = function(){
    if($(window).width() > CONST.BREAKPOINT){
        return true;
    }
    return false;
};

//========================================
Tk.mediaQuery([CONST.BREAKPOINT], function(zone){
    //....
}, function(bp, sizedown){
    $("html").hide();
    location.reload();
});

if(Tk.checkUA("trident")){
    $("html").addClass("ie11");
}else if(Tk.checkUA("msie")){
    $("html").addClass("ie10b");
}

//========================================
var flg_youtube_ready   = false;
var flg_youtube_playing = false;
ytFunc.onReady = function(){
    flg_youtube_ready = true;
};
ytFunc.onPlay = function(){
    if( !flg_youtube_playing ){
        flg_youtube_playing = true;
    }
};
ytFunc.onPause = function(){
};
ytFunc.onEnd = function(){
    ytobj.stopVideo();
    flg_youtube_playing = false;
    
    $moviecover.show();
    setTimeout(function(){
        $moviecover.removeClass("conceal");
    }, 400);
};
var $moviecover = $("section.lineup div.moviebox div.cover");
$moviecover.find("label").on("click", function(){
    if(!flg_youtube_ready){
        console.log("YT state: not ready..");
        return;
    }
    $moviecover.addClass("conceal");
    setTimeout(function(){
        $moviecover.hide();
    }, 400);
    ytobj.playVideo();

});

//========================================
var specinfolist = {
"a":[[
    "UPPER",
    "アッパーデザイン",
    '胸郭のように包み込む<br class="pc" />アッパーデザイン。',
    '両側から肋骨のように足を包む構造により、足をしっかりと固定。さらに後ろから前へと伸びるパーツにはシリコンの芯が内蔵され、着地時の足のブレを抑制する。'
    ],[
    "CUSHION",
    "クッション技術",
    '履き心地の真骨頂。<br class="pc" />空気で支えるクッション技術。',
    '地面からの衝撃を吸収し、歩行を安定させるメレル独自の「エアー クッション」を搭載。着地時にカップ状にかかとを包み込み、歩行時の疲労を軽減する。'
    ],[
    "INSOLE",
    "インソール",
    '足の形やフィット感が<br class="pc" />計算されたインソール。',
    '柔らかく弾力のあるEVA素材がブレンドされたインソール。土踏まずのアーチとかかとをしっかりとサポートしながら、低反発な足当たりを実現する。'
    ],[
    "GORE-TEX&reg;",
    "ゴアテックス&reg;",
    '信頼の防水透湿メンブレン<br class="pc" />「ゴアテックス&reg;」。',
    '優れた防水性と透湿性を両立した、ゴア社の特許素材「ゴアテックス&reg;」を搭載。水の浸入を防ぐだけでなく、水たまりやぬかるんだ道の歩行、突然の豪雨に見舞われても足室内を快適に保つ。'
    ],[
    "VIBRAM OUTSOLE",
    "ヴィブラム アウトソール",
    '大地を確実につかむ<br class="pc" />「ヴィブラム アウトソール」。',
    '世界のアウトドアフリークがその実力を認める「ヴィブラム アウトソール」を採用。優れた耐久性とグリップ力で、荒れた路面やぬかるんだフィールドでも、確実に前へと進む推進力を発揮する。'
    ]
],
"b":[[
    "MIDSOLE",
    "ミッドソール",
    'パフォーマンスが持続する<br class="pc" />超軽量ミッドソール。',
    '相反する「軽さ」と「耐久性」を両立した「フロートプロ&trade;」を搭載。長時間の反発弾性を確保し、パフォーマンスを持続させる。環境負荷の低減のため廃材を出さない製造工程で、再利用しやすいTPE素材を採用。'
    ],[
    "RUG",
    "トラクションラグ",
    '細かく刻まれたラグで<br class="pc" />荒れた路面にも対応。',
    'ヴィブラム社の最新特許技術「トラクションラグ」。細かな段差のある山型のラグ形状が、着地面を増加させることで、これまでのトラクションより最大25％の向上を実現。'
    ],[
    "GORE-TEX&reg;",
    "ゴアテックス&reg;",
    '信頼の防水透湿メンブレン<br class="pc" />「ゴアテックス&reg;」。',
    '優れた防水性と透湿性を両立した、ゴア社の特許素材「ゴアテックス&reg;」を搭載。水の浸入を防ぎ、足室内を快適に保つ。'
    ],[
    "VIBRAM OUTSOLE",
    "ヴィブラム アウトソール",
    'メレル専用に開発された<br class="pc" />サステナブルソール。',
    'リサイクル素材を30％以上配合して作られたメレル専用の「ヴィブラム エコデュラ アウトソール」。耐久性、パフォーマンス性を一切妥協することなく、サステナビリティを体現。'
    ]
],
"c":[[
    "UPPER",
    "テキスタイルアッパー",
    '細やかな「ジャガード織」で<br class="pc" />立体感を演出。',
    '高級感ある「ジャガード織」を採用したテキスタイルアッパー。つま先やかかと部分のジグザグステッチや、4本の特徴的なデザインラインも立体的な仕上がりに。'
    ],[
    "MIDSOLE",
    "ミッドソール",
    'パフォーマンスが持続する<br class="pc" />超軽量ミッドソール。',
    '相反する「軽さ」と「耐久性」を両立した「フロートプロ&trade;」を搭載。長時間の反発弾性を確保し、パフォーマンスを持続させる。環境負荷の低減のため廃材を出さない製造工程で、再利用しやすいTPE素材を採用。'
    ],[
    "VIBRAM OUTSOLE",
    "ヴィブラム アウトソール",
    'メレル専用に開発された<br class="pc" />サステナブルソール。',
    'リサイクル素材を30％以上配合して作られたメレル専用の「ヴィブラム エコデュラ アウトソール」。ハイクオリティなコンパウンドにより、耐久性、パフォーマンス性を一切妥協することなく、サステナビリティを体現。'
    ],[
    "BREATHABLE",
    "通気性",
    '足室内は、通気性を<br class="pc" />高めるメッシュ仕立て。',
    'シューズの内側は、メッシュ仕立てで長時間の走行時もムレにくく、サラッとした足当たり。履く時の足入れもスムーズ。'
    ],[
    "RECYCLE",
    "リサイクル素材",
    'サステナブルを<br class="pc" />意識した素材を随所に。',
    'アッパーには、70％リサイクル素材を採用し、優れた通気性を実現。シューレースには100％リサイクル素材を採用した。'
    ]
]};
var htmlstr = '';
var fm = '';
fm += '<div class="each n{%}">';
    fm += '<dl>';
        fm += '<dt>';
            fm += '<label>';
                fm += '<p>';
                    fm += '<em>{%}</em>';
                    fm += '<span>{%}</span>';
                fm += '</p>';
                fm += '<i class="mrk"><svg viewBox="0 0 2 2" preserveAspectRatio="none"><use xlink:href="#svg_tri1_e"></use></svg></i>';
            fm += '</label>';
        fm += '</dt>';
        fm += '<dd>';
            fm += '<div class="inbox">';
                fm += '<div class="note">';
                    fm += '<div class="maintx">';
                        fm += '<p>{%}</p>';
                    fm += '</div>';
                    fm += '<div class="subtx">';
                        fm += '<p>{%}</p>';
                    fm += '</div>';
                fm += '</div>';
                fm += '<div class="fig">';
                    fm += '<figure class="imageobj"></figure>';
                fm += '</div>';
            fm += '</div>';
        fm += '</dd>';
    fm += '</dl>';
fm += '</div>';
htmlstr = '';
for(var i=0,imax=specinfolist.a.length; i<imax; i++){ var v=specinfolist.a[i];
    htmlstr += Tk.sprintf(fm, [
        (i + 1), v[0],v[1],v[2],v[3]
    ]);
}
$("section.lineup.standard div.specbox div.block").html(htmlstr);
htmlstr = '';
for(var i=0,imax=specinfolist.b.length; i<imax; i++){ var v=specinfolist.b[i];
    htmlstr += Tk.sprintf(fm, [
        (i + 1), v[0],v[1],v[2],v[3]
    ]);
}
$("section.lineup.speed div.specbox div.block").html(htmlstr);
htmlstr = '';
for(var i=0,imax=specinfolist.c.length; i<imax; i++){ var v=specinfolist.c[i];
    htmlstr += Tk.sprintf(fm, [
        (i + 1), v[0],v[1],v[2],v[3]
    ]);
}
$("section.lineup.flight div.specbox div.block").html(htmlstr);
setTimeout(function(){
    var flg_working_spec = false;
    $("section.lineup div.specbox div.block label").on("click", function(){
        if(flg_working_spec){
            return;
        }
        flg_working_spec = true;
        
        var $box = $(this).closest("div.each");
        if($box.hasClass("open")){
            $box.find("dd div.inbox").removeClass("appear");
            $box.removeClass("open");
            $box.find("dd").slideUp(400, function(){
                setTimeout(function(){
                    flg_working_spec = false;
                }, 200);
            });
        }else{
            $box.addClass("open");
            $box.find("dd").slideDown(400, function(){
                $box.find("dd div.inbox").addClass("appear");
                setTimeout(function(){
                    flg_working_spec = false;
                }, 200);
            });
        }
    });
}, 200);

//========================================
var edge_scroller = 0;
if(Tk.isPC()){
    edge_scroller = 1000;
}else{
    edge_scroller = Math.floor($(window).width() * 400/100);
}
$(window).on("scroll.scroller", function(){
    var ypos = $(this).scrollTop();
    if(ypos >= edge_scroller){
        $("label.totopbutton").addClass("appear");
    }else{
        $("label.totopbutton").removeClass("appear");
    }
});
$("label.totopbutton").on("click", function(){
    Tk.scroll(null, 0, 1000);
});
$("footer div.goback label").on("click", function(){
    $("label.totopbutton").trigger("click");
});

//========================================
var Mb0 = new Modalbox($("#navigation"), {
    appendTo: "#wrap",
    bgColor: "rgba(0,0,0,0)"
});
Mb0.flg_act = false;
$("header div.navibtn label").on("click", function(){
    if(Mb0.working){
        return;
    }
    if($(this).hasClass("open")){
        $(this).removeClass("open");
        $("nav div.listbox ul>li").each(function(i, e){
            setTimeout(function(){
                $(e).find("i.bg").removeClass("act");
            }, 80 * (i + 1));
        });
        setTimeout(function(){
            Mb0.hide();
        }, 200);
    }else{
        $(this).addClass("open");
        Mb0.show(function(){
            $("nav div.listbox ul>li").each(function(i, e){
                setTimeout(function(){
                    $(e).find("i.bg").addClass("act");
                }, 80 * (i + 1));
            });
        });
    }
});
Mb0.$box.find("div.rim").on("click", function(ev){
    ev.stopPropagation();
});
Mb0.$box.on("click", function(){
    $("header div.navibtn label").trigger("click");
});
Mb0.$box.find("div.listbox label").on("click", function(){
    var idx  = Mb0.$box.find("div.listbox label").index(this);
    var $aim = null;
    var mgn  = $("header").height();
    switch(idx){
        case 0:
            $aim = $("section.eyecatch");
            break;
        case 1:
            $aim = $("section.lineup.standard");
            break;
        case 2:
            $aim = $("section.lineup.speed");
            break;
        case 3:
            $aim = $("section.lineup.flight");
            break;
        default:
    }
    $("header div.navibtn label").trigger("click");
    setTimeout(function(){
        Tk.scroll($aim, mgn, 1000);
    }, 700);
});

//========================================
$("*[my_scrleff]").on("myInvade", 3/10, function(){
    var $elm = $(this);
    var eff  = $elm.attr("my_scrleff");
    $elm.addClass("appear");
    if(eff === "x1"){
        setTimeout(function(){
            $elm.find("h2").addClass("appear");
        }, 800);
    }else if(eff === "x2"){
        var lp = 0;
        $elm.find("h2 p").eq(0).find("i").each(function(i, e){
            setTimeout(function(){
                $(e).addClass("appear");
                lp++;
                if(lp >= 6){
                    setTimeout(function(){
                        $elm.find("h2 p").eq(1).find("span").addClass("appear");
                        setTimeout(function(){
                            $elm.find("div.history").addClass("appear");
                        }, 500);
                    }, 500);
                }
            }, 200 * (i + 1));
        });
    }else if(eff === "x3"){
        setTimeout(function(){
            $elm.find("p").addClass("appear");
        }, 400);
    }else{
        //..
    }
});
$(window).trigger("scroll");

//========================================
var kvobj = {
    id  : "#keymovie",
    src : (Tk.isPC())?("https://cdn.shopify.com/s/files/1/0265/3261/0091/files/moab_movie_visual_pc.mp4?v=1641532702"):("https://cdn.shopify.com/s/files/1/0265/3261/0091/files/moab_movie_visual_sp.mp4?v=1641532702"),
    org : (Tk.isPC())?([1366,750]):([750,1350]),
    $me : $("section.visual div.animatebox div.kvwrap video"),
    calc: function(w0, h0, w1, h1){
        var rx,ry,rw,rh;
        if(h1 / w1 > h0 / w0){
            rw = h1 * (w0 / h0);
            rh = h1;
            rx = (w1 - rw) / 2;
            ry = 0;
        }else{
            rh = w1 * (h0 / w0);
            rw = w1;
            rx = 0;
            ry = (h1 - rh) / 2;
        }
        return [rx,ry,rw,rh];
    }
};
$(window).on("resize.visualfit", function(){
    var rsl  = [];
    //--
    $("section.visual").height($(window).height() - $("header").height());
    //--
    rsl = kvobj.calc(kvobj.org[0], kvobj.org[1], kvobj.$me.parent().width(), kvobj.$me.parent().height());
    kvobj.$me.css({
        left  : rsl[0],
        top   : rsl[1],
        width : rsl[2],
        height: rsl[3]
    });
}).trigger("resize.visualfit");

var Mv1 = new MvPlayer($(kvobj.id), kvobj.src, {
    onReady: function(mv){
        Tk.stepRun([
            function(next){
                setTimeout(next, 500);
            },
            function(next){
                $("html").animate({opacity:1}, 1000, "linear", next);
            },
            function(next){
                Mv1.restart();
            }
        ]);
    },
    onEnd  : function(mv){
        Tk.stepRun([
            function(next){
                setTimeout(next, 400);
            },
            function(next){
                $("section.visual div.letsgo").addClass("appear");
            }
        ]);
    }
});

}); // end of wrap func